<template>
    <div>
        <v-breadcrumbs :items="crumbs" divider="/" style="background-color: #f0f0f0">
        </v-breadcrumbs>
        <v-card class="mx-auto" outlined tile color="#F8F8FF">
        <v-card-title>CO+ Visa Master</v-card-title>
        <v-container fluid>
            <v-row>
                <v-btn-toggle class="col-12 offset-md-6 col-md-6" style="background: none">
                    <v-btn small disabled>
                        <v-icon small>fa fa-search</v-icon>
                    </v-btn>
                    <v-text-field placeholder="Search" class="search-textfield" hide-details outlined dense v-model="search"></v-text-field>
                </v-btn-toggle>
            </v-row>
            <v-row>
                <v-col cols="12" md="12">
                    <v-autocomplete
                            dense
                            outlined
                            placeholder="All Operator"
                            label="Operator"
                            v-model="operator.selected"
                            @change="execFilter('operator')"
                            :items="operator.items"
                            item-text="name"
                            item-value="OperatorID"
                            :rules="operator.rule"
                            :loading="operator.loader"
                            :disabled="operator.disable"
                            hide-details
                            >
                            </v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                    <v-autocomplete
                    dense
                    outlined
                    placeholder="All Car Park"
                    label="Car Park"
                    v-model="carpark.selected"
                    @change="execFilter('carpark')"
                    :items="carpark.items"
                    item-text="name"
                    item-value="CarParkID"
                    :rules="carpark.rule"
                    :loading="carpark.loader"
                    :disabled="carpark.disable"
                    hide-details
                    >
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12">
                    <vc-date-picker
                    :disabled-dates="dayplusone"
                     :key="counter1" v-model="starttime.item" mode="date" is-range update-on-input :popover="{visibility: 'click'}" @drag="cleardayplusone($event)" @input="onDateRangeChange" :columns="$screens({ default: 1, lg: 2 })" :masks="{ input: 'DD-MM-YYYY' }" :max-date="(new Date())">
                      <template v-slot="{ inputEvents, togglePopover }">
                            <v-text-field
                                @click="togglePopover({ placement: 'bottom-start' })"
                                :value="dateRangeLabel"
                                dense
                                v-on="inputEvents"
                                hide-details="auto"
                                label="Date range"
                                outlined
                                autocomplete="off"
                            ></v-text-field>
                        </template>
                      </vc-date-picker>
                    <div class="text-caption grey--text text--darken-1">You can only choose a date range of up to 31 days.</div>
                </v-col>
            </v-row>
            
            <v-row>
                <v-col cols="12" md="8">
                    <v-pagination
                    v-model="page"
                    :length.sync="pages"
                    :total-visible="6"
                    class="mt-4"
                    style="float: left !important"
                    ></v-pagination><br/><p class="text-caption" style="margin-left: 10px">Page {{page}} of {{pages}}</p>
                </v-col>
            </v-row>
           
            <v-row dense>
                <v-col cols="12"><v-btn outlined tile small color="primary" type="button" v-on:click="getForReport" :disabled="counter1 == 0 || reportloader" :loading="reportloader"><v-icon x-small left>fa fa-download</v-icon> Download Report
                <template v-slot:loader>
                            <span>Downloading Report...</span>
                        </template>
                </v-btn>
                </v-col>
                <v-col><span class="text-body-2">View {{page > 1 ? (page - 1) * 100 + 1 : 1}} - {{getCount}} of {{totalrecords}}</span></v-col>
                <v-col cols="12" md="12" id="table-parent">
                    <div id="wrapper1">
                        <div id="div1">
                        </div>
                    </div>
                    <v-data-table
                        calculate-widths
                        :headers="headers"
                        :items="items"
                        hide-default-footer
                        :loading="tableloading"
                        loading-text= "Loading Data... Please wait"
                        :items-per-page="100"
                        id="main-table"
                        dense
                    >
                    <template slot="item" slot-scope="props">
                        <tr>
                            <td>{{props.index + 1}}</td>
                            <td>
                                {{props.item.ID}}
                            </td>
                            <td>{{props.item.Mid != null ? props.item.Mid : 'N/A'}}</td>
                            <td>{{props.item.Tid != null ? props.item.Tid : 'N/A'}}</td>
                            <td>{{props.item.CarParkID}}</td>
                            <td>{{props.item.CarParkName}}</td>
                            <td>{{props.item.ExitGateID}}</td>
                            <td>{{props.item.CardScheme}}</td>
                            <td>{{props.item.TicketID}}</td>
                            <td>{{props.item.TransID}}</td>
                            <td>{{props.item.MaskPan}}</td>
                            <td>{{props.item.ParkingEntryDateTime}}</td>
                            <td>{{props.item.ParkingExitDateTime}}</td>
                            <td>{{props.item.CreatedDateTime}}</td>
                            <td>{{props.item.Amount_Paid}}</td>
                            <td>{{props.item.BatchNo != null ? props.item.BatchNo : 'N/A'}}</td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
        </v-card>
        <v-snackbar
        v-model="swal.notification"
        top
        :color="swal.scolor"
        >
            {{ swal.message }}
        </v-snackbar>
    </div>
</template>
<script>
import timer from '../../assets/js/sleeper.js';
import create from '.././modals/CreateSystem';
import alert from '.././modals/Alert';
import {ERR} from '../../assets/js/errhandle.js';
import alertbox2 from '../modals/Notification';
import * as moment from "moment";
import * as tz from "moment-timezone";
import {rule} from '../../assets/js/checkPerm.js';
import dpicker from "../DatePickerComponent";
import XLSX from 'xlsx';

export default {
    name: 'CoherentTransactions',
    title: 'CoherentTransactions',
    
    data()  {
        return {
            crumbs: [
                {
                text: 'Home',
                disabled: true,
                href: '#',
                },

                {
                text: 'Report',
                disabled: true,
                href: '#',
                },

                {
                text: 'Card Reader',
                disabled: true,
                href: '#',
                },

                {
                text: 'CO+ Visa Master',
                disabled: true,
                href: '#',
                }
            ],
            items: [],
            search: '',
            headers: [
                { text: '#', value: 'ID', width: '3%' },
                { text: 'ID', value: 'ID', width: '3%' },
                { text: 'MID', value: 'BatchAmount', width: '3%' },
                { text: 'TID', value: 'BatchAmount', width: '3%' },
                { text: 'CP ID', value: 'SettlementDate', width: '3%' },
                { text: 'Car Park', value: 'SettlementDate', width: '7%' },
                { text: 'Gate ID', value: 'SettlementDate', width: '3%' },
                { text: 'Card Scheme', value: 'BatchCount', width: '3%' },
                { text: 'Ticket ID', value: 'SettlementDate', width: '3%' },
                { text: 'Trxn ID', value: 'SettlementDate', width: '7%' },
                { text: 'Card Number', value: 'BatchAmount', width: '3%' },
                { text: 'Entry Date', value: 'CreatedDateTime', width: '7%' },
                { text: 'Exit Date', value: 'CreatedDateTime', width: '7%' },
                { text: 'Payment Date', value: 'CreatedDateTime', width: '7%' },
                { text: 'Amount (RM)', value: 'SettlementDate', width: '3%' },
                { text: 'Batch No', value: 'BatchNo', width: '3%' },
            ],
            tableloading: false,
            btn_loading: false,
            pages: 0,
            page: 1,
            swal: {
                notification: false,
                message: '',
                scolor: '',
            },
            ma: {
                modal: false,
                modal_action_type: '',
                modalInfo: [],
                customText: [],
                confirmCreate: false,

                modal_status: false,
                modal_update: false,
                readonly: true,
                allInfo: [],

                modal_pdf: '',
            },
            pdfurl: '',

            ex: {
                modal: false,
                content: {
                    headline: '',
                    icon: '',
                    chipColor: '',
                    iconColor: '',
                    maintext: '',
                    smalltext: ''
                }
            },

            operator: {
                items: [],
                itemsFull: [],
                selected: '',
                loader: false,
                disable: false,
                rule: []
            },
            carpark: {
                items: [],
                itemsFull: [],
                selected: '',
                loader: false,
                disable: false,
                rule: []
            },
            displaystatus: {
                counter: 0,
                selected: null,
                rerender: 0,
                label: 'All Mobile Display Status'
            },
            toggle_exclusive_search: 0,
            totalrecords: '',
            starttime: {item: {start: moment().subtract(1, 'month').startOf('day').toDate(), end: moment().startOf('day').toDate()}},
            endtime: {item: ''},
            starttimeforapi: '',
            endtimeforapi: '',
            dayplusone: [],
            show: false,
            counter1: 0,
            dataforexport: [],
            reportloader: false
        }
    },

    components: {create, alert, alertbox2, dpicker},

    async created(){
        await this.getOperatorFull();
        await this.getCarParkFull();
        //await this.setTime();
        await this.listItems(1);
        this.show = true;
        this.horizontalScroll();
    },

    watch: {
        page: {
        handler: function(value) {
            this.items = [];
            this.listItems();
        }
        },

        'search': {
        handler: function(value) {
            this.searchTimeOut();
        }
        },

        'toggle_exclusive_search': {
        handler: function(value) {
            if (this.search != '')
            this.searchTimeOut();
        }
        },
    },

    computed: {
        dateRangeLabel(){
            const start = this.starttime.item.start;
            const end = this.starttime.item.end;
            if (!start) return '';
            const startLabel = moment(start).format('DD-MM-YYYY');
            return end ? `${startLabel} - ${moment(end).format('DD-MM-YYYY')}` : startLabel;
        },
        getCount(){
            if (this.items.length > 0)
                return this.items[this.items.length - 1].row;

                else{
                    return '';
                }
            },
    },

    methods: {
        async listItems(pg){
            try{
                this.tableloading = true;
                this.setTime();
                this.counter1++;
                let response = await this.$store.dispatch("getCoherentTransaction", { rows: 100, page: pg> 0? this.page = pg: this.page, search: this.search, operatorid: this.operator.selected, carparkid: this.carpark.selected, startdate: this.starttimeforapi, enddate: this.endtimeforapi, type: 'visa' });
                let response2 = await this.$store.dispatch("getAllCarpark2", {search: ''});
                let dt2 = response2.data.record;
                if (response.data.code == 'AP000'){
                    this.$vuetify.goTo(0);

                let dt = response.data.record;
                //let recordCount = response.data.recordcount[0].resultcount;
                this.totalrecords = response.data.total;

                for(var i=0; i<dt.length; i++){
                    dt[i].CreatedDateTime = dt[i].CreatedDateTime != null ? moment(dt[i].CreatedDateTime).format('DD-MM-YYYY hh:mm:ss A') : 'N/A'
                    dt[i].ParkingEntryDateTime = dt[i].ParkingEntryDateTime != null ? moment(dt[i].ParkingEntryDateTime).format('DD-MM-YYYY hh:mm:ss A') : 'N/A'
                    dt[i].ParkingExitDateTime = dt[i].ParkingExitDateTime != null ? moment(dt[i].ParkingExitDateTime).format('DD-MM-YYYY hh:mm:ss A') : 'N/A'
                    dt[i].SettlementDate = dt[i].SettlementDate != null ? moment(dt[i].SettlementDate).format('DD-MM-YYYY hh:mm:ss A') : 'N/A'
                    let carpark = dt2.find(item => item.CarParkID == dt[i].CarParkID);
                    dt[i].CarParkName = carpark!= null? carpark.CarParkName : 'N/A'
                }
                
                this.items = dt;
                this.pages = Math.ceil(this.totalrecords / 100);
                //await this.getForReport();
                }

                else{
                    this.items = [];
                }

                this.tableloading = false;
            }

            catch(err){
                console.log(err);
            }
        },
        onDateRangeChange(range){
            range = range || this.starttime.item;
            if (!range || !range.start || !range.end) return;
            const latestEnd = moment(range.start).add(30, 'days').endOf('day');
            if (moment(range.end).isAfter(latestEnd)) {
                this.starttime.item.end = latestEnd.toDate();
            }
            this.listItems(1);
        },
        cleardayplusone(range){
            if (!range || !range.start) {
                this.dayplusone = null;
                return;
            }
            this.dayplusone = [{ start: moment(range.start).add(31, 'days').startOf('day').toDate(), end: null }];
        },
        async getForReport(){
            this.reportloader = true;
            try {
                const response = await this.$store.dispatch("getCoherentTransaction", { rows: 9999999, page: 1, search: this.search, operatorid: this.operator.selected, carparkid: this.carpark.selected, startdate: this.starttimeforapi, enddate: this.endtimeforapi, type: 'visa' });
                const records = response.data.record || [];
                const response2 = await this.$store.dispatch("getAllCarpark2", {search: ''});
                const carparks = response2.data.record || [];
                let total = 0;
                this.dataforexport = records.map(doc => {
                    const amount = Number(doc.Amount_Paid) || 0;
                    total += amount;
                    const carpark = carparks.find(item => item.CarParkID == doc.CarParkID);
                    return {
                        ID: doc.ID,
                        MID: doc.Mid != null ? doc.Mid : 'N/A',
                        TID: doc.Tid != null ? doc.Tid : 'N/A',
                        'Car Park ID': doc.CarParkID,
                        'Car Park': carpark ? carpark.CarParkName : 'N/A',
                        'Gate ID': doc.ExitGateID,
                        'Card Scheme': doc.CardScheme,
                        'Ticket ID': doc.TicketID,
                        'Transaction ID': doc.TransID,
                        'Card Number': doc.MaskPan,
                        'Entry Date': doc.ParkingEntryDateTime != null ? moment(doc.ParkingEntryDateTime).format('DD-MM-YYYY hh:mm:ss A') : 'N/A',
                        'Exit Date': doc.ParkingExitDateTime != null ? moment(doc.ParkingExitDateTime).format('DD-MM-YYYY hh:mm:ss A') : 'N/A',
                        'Payment Date': doc.CreatedDateTime != null ? moment(doc.CreatedDateTime).format('DD-MM-YYYY hh:mm:ss A') : 'N/A',
                        'Amount (RM)': amount.toFixed(2),
                        'Batch No': doc.BatchNo != null ? doc.BatchNo : 'N/A',
                    };
                });
                const keys = Object.keys(this.dataforexport[0] || {
                    ID: '', MID: '', TID: '', 'Car Park ID': '', 'Car Park': '', 'Gate ID': '',
                    'Card Scheme': '', 'Ticket ID': '', 'Transaction ID': '', 'Card Number': '',
                    'Entry Date': '', 'Exit Date': '', 'Payment Date': '', 'Amount (RM)': '', 'Batch No': ''
                });
                const totalRow = keys.reduce((row, key) => { row[key] = ''; return row; }, {});
                totalRow['Payment Date'] = 'Grand Total';
                totalRow['Amount (RM)'] = total.toFixed(2);
                this.dataforexport.push(totalRow);
                this.onexport();
            } catch (err) {
                console.log(err);
                this.swal.message = 'Unable to prepare the CSV report.';
                this.swal.scolor = 'error';
                this.swal.notification = true;
            } finally {
                this.reportloader = false;
            }
        },


        async getOperatorFull(){
            let list = [];
            this.operator.items = [];
            this.operator.selected = "";

            try{
                this.operator.loader = true;
                this.operator.disable = true;

                let self = this;
                let response = await this.$store.dispatch("listOperator", {search: ''});
                let dt = response.data.record;
                if (response.data.code == 'AP000'){
                    this.operator.items.push({name: "All Operators", OperatorID: ""});
                    this.operator.itemsFull.push({name: "All Operators", OperatorID: ""});

                for(var i=0; i<dt.length; i++){
                    if (dt[i].SystemID === 2){
                        dt[i].name = `${dt[i].OperatorID} - ${dt[i].OperatorName}`;
                        this.operator.items.push({name: dt[i].name, OperatorID: dt[i].OperatorID});
                        this.operator.itemsFull.push(dt[i]);
                    }
                }

                this.operator.selected = this.operator.items[0].OperatorID;
                }

                //this.operator.itemsFull = dt;

                this.operator.loader = false;
                this.operator.disable = false;
            }

            catch(err){
                console.log(err);
            }

            return list;
        },

        async getCarParkFull(){
            let list = [];
            this.carpark.items = [];
            this.carpark.selected = "";

            try{
                this.carpark.loader = true;
                this.carpark.disable = true;

                let self = this;

                if (this.operator.selected){
                    let carpark = this.carpark.itemsFull.filter(item => {
                    return item.OperatorID == self.operator.selected;
                    });

                    this.carpark.items.push({name: "All Car Parks", CarParkID: ""});

                    for(var i=0; i<carpark.length; i++){
                        carpark[i].name = `${carpark[i].CarParkID} - ${carpark[i].CarParkName}`;
                        this.carpark.items.push({name: carpark[i].name, CarParkID: carpark[i].CarParkID});
                    }

                    //this.operator.selected = this.operator.items[1].OperatorID;
                }

                else{
                    let response = await this.$store.dispatch("getAllCarpark2", {});
                    let dt = response.data.record;
                    if (response.data.code == 'AP000'){
                        this.carpark.items.push({name: "All Car Parks", CarParkID: ""});
                        this.carpark.itemsFull.push({name: "All Car Parks", CarParkID: ""});

                    for(var i=0; i<dt.length; i++){
                        dt[i].name = `${dt[i].CarParkID} - ${dt[i].CarParkName}`;
                        this.carpark.items.push({name: dt[i].name, CarParkID: dt[i].CarParkID});
                        this.carpark.itemsFull.push(dt[i]);
                    }

                    this.carpark.selected = this.carpark.items[0].CarParkID;
                    }
                }

                //this.operator.itemsFull = dt;

                this.carpark.loader = false;
                this.carpark.disable = false;
            }

            catch(err){
                console.log(err);
            }

            return list;
        },

        validateAccess(val){
            let access = JSON.parse(JSON.stringify(this.$store.getters.getAccess))
            return rule.checkaccess(val, access);
        },

        viewMore(row, flag){
            //this.autoRefresh = 0;
            if (flag == 'delete'){
                this.ma.modal_status = true;
                this.ma.modalInfo = row;
            }

            if (flag == 'create'){
                this.ma.modal = true;
                this.ma.allInfo = this.items;
            }

            if (flag == 'update'){
                this.ma.modal_update = true;
                this.ma.modalInfo = row;
                this.ma.allInfo = this.items;
                this.ma.readonly = false;
            }

            if (flag == 'view_details'){
                this.ma.modal_update = true;
                this.ma.modalInfo = row;
                this.ma.allInfo = this.items;
                this.ma.readonly = true;
            }

            if (flag == 'view_pdf'){
                this.ma.modal_pdf = true;
                this.ma.modalInfo = row;
                this.pdfurl = row.InvoiceReceiptURL;
            }

            this.ma.customText = {text1: "Gate ID", text2: "Name"};
            this.ma.modal_action_type = flag;
        },

        update(row){
            this.ma.modalInfo = row;
            this.$router.push({ name: "Update", params: {id: row.ValuePassProductID}});
        },

        onClosed(value){
            console.log(value)
            if (value == false){
                this.ma.modal = value;
                this.ma.modal_status = value;
                this.ma.modal_update = value;
                this.ex.modal = value;
                this.ma.modal_pdf = value;
            }
        },

        /*
        onConfirm(value){
            console.log(value)
            if (value.flag === 'create'){
                this.ma.confirmCreate = true;
                this.ma.modal = false;
                this.addSystem(value);
            }

            if (value.flag === 'update'){
                this.ma.modal_update = false;
                this.systemUpdate(value);
            }

            if (value === true){
                if (this.ma.modal_action_type == 'delete')
                {
                    this.ma.modal_status = false;
                    this.systemRemove();
                }
            }
        },
        */

        async execFilter(type){
            if (type == 'system'){
                await this.getOperatorFull();
                await this.getCarParkFull();
                await this.searchTimeOut();
            }

            if (type == 'operator'){
                await this.getCarParkFull();
                await this.searchTimeOut();
            }

            if (type == 'carpark'){
                await this.searchTimeOut();
            }

            if (type == 'displaystatus'){
                this.displaystatus.counter++;
                if (this.displaystatus.counter % 3 == 0){
                    this.displaystatus.rerender++;
                    this.displaystatus.selected = null;
                    this.displaystatus.label = "All Mobile Display Status";
                }

                if (this.displaystatus.selected === true){
                    this.displaystatus.label = "Mobile Display Status Enable";
                }

                if (this.displaystatus.selected === false){
                    this.displaystatus.label = "Mobile Display Status Disable";
                }
                await this.searchTimeOut();
            }
        },

        searchTimeOut() {

          clearTimeout(this.timeout);

          // Make a new timeout set to go off in 800ms
          this.timeout = setTimeout(() => {
          this.listItems(1);
          }, 800);
        },

        horizontalScroll(){
            var wrapper1 = document.getElementById('wrapper1');
            var wrapper2 = document.querySelector('.v-data-table__wrapper');
            document.getElementById('wrapper1').style.width = `${String(document.getElementsByClassName("v-data-table__wrapper")[0].offsetWidth)}px`;
            document.getElementById('div1').style.width = `${String(document.getElementsByTagName("table")[0].offsetWidth)}px`;

            if (document.getElementsByClassName("v-data-table-header")[0].offsetWidth < document.getElementById("table-parent").offsetWidth)
                    document.getElementById('wrapper1').style.display = "none";

                else
                    document.getElementById('wrapper1').style.display = "block";

            window.addEventListener('resize', function() {
                document.getElementById('wrapper1').style.width = `${String(document.getElementsByClassName("v-data-table__wrapper")[0].offsetWidth)}px`;
                document.getElementById('div1').style.width = `${String(document.getElementsByTagName("table")[0].offsetWidth)}px`;

                if (document.getElementsByClassName("v-data-table-header")[0].offsetWidth < document.getElementById("table-parent").offsetWidth)
                    document.getElementById('wrapper1').style.display = "none";

                else
                    document.getElementById('wrapper1').style.display = "block";
            });

            const myObserver = new ResizeObserver(entries => {
            entries.forEach(entry => {
                document.getElementById('wrapper1').style.width = `${String(document.getElementsByClassName("v-data-table__wrapper")[0].offsetWidth)}px`;
                document.getElementById('div1').style.width = `${String(document.getElementsByTagName("table")[0].offsetWidth)}px`;
                console.log('table', document.getElementsByClassName("v-data-table__wrapper")[0].offsetWidth);
                console.log('parent', document.getElementById("table-parent").offsetWidth);

                if (document.getElementsByClassName("v-data-table-header")[0].offsetWidth < document.getElementById("table-parent").offsetWidth)
                    document.getElementById('wrapper1').style.display = "none";

                else
                    document.getElementById('wrapper1').style.display = "block";
            });
            });

            const someEl = document.getElementsByTagName("table")[0];
            myObserver.observe(someEl);


            wrapper1.onscroll = function() {
            wrapper2.scrollLeft = wrapper1.scrollLeft;
            };
            wrapper2.onscroll = function() {
            wrapper1.scrollLeft = wrapper2.scrollLeft;
            };
        },

        /*
        dateValStartTime(value){
            this.starttime.item = value;
            this.execFilter('date');
        },

        dateValEndTime(value){
            this.endtime.item = value;
            this.execFilter('date');
        },
        */

        setTime(){
            console.log('this.starttime.item.start', this.starttime.item.start);
            let starttime = this.starttime.item.start ? moment(new Date(this.starttime.item.start)).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD');
            if (this.starttime.item.start == ""){
                this.starttime.item.start = new Date(moment(starttime));
            }
            this.starttimeforapi = moment(starttime).format('YYYY-MM-DD');
            let endtime = this.starttime.item.end ? moment(new Date(this.starttime.item.end)).format('YYYY-MM-DD') : this.starttimeforapi;
            if (!this.starttime.item.end) this.starttime.item.end = new Date(moment(endtime));
            this.endtimeforapi = endtime;

            // Add a day
            this.dayplusone = null;
        },

        async downloadFile(name, date){
            let itms = this.items.filter(itm => itm.fileName == name);
            for(var i=0; i<itms.length; i++){
                itms[i].rowloader = true;
            }

            try{
                // let dt = atob(itms);
                this.exportCSVFile({ name: 'Name' }, itms, name);
                // let response = await this.$store.dispatch("getDuitNowFinanceSFTPBase64", {folderyyyymmdd: date, filenamewithext: name });

                // if (response.data.code == 'AP000'){
                // }

                for(var i=0; i<itms.length; i++){
                    itms[i].rowloader = false;
                }

                this.items = itms;
            }

            catch(err){
                console.log(err);
            }
        },

        exportCSVFile(headers, items, fileTitle) {
            const csv = items[0];
            const exportedFilename = fileTitle || 'export.csv'; // eslint-disable-line
            // const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, exportedFilename);
            } else {
                const link = document.createElement('a');
                // console.log(link)
                if (link.download !== undefined) {
                // const url = URL.createObjectURL(blob);
                link.setAttribute('href', csv.url);
                link.setAttribute('download', exportedFilename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                }
            }
        },

        isToday() {
            return moment(new Date()).format('DD-MM-YYYY');
        },

        onexport () { // On Click Excel download button
        // export json to Worksheet of Excel
        // only array possible
        /*
        7. #, Ref. No., Transaction ID, Trxn Ref., Merchant ID, Payment Method, CP ID, Car Park, Name, Mobile No., Email, Transaction Date, Product, Amount (RM), Finance (RM), Finance SST (RM), Net Amount (RM)
        */
            const headers = Object.keys(this.dataforexport[0] || {});
            const rows = this.dataforexport.map(item => headers.map(header => item[header]));
            const sheet = XLSX.utils.aoa_to_sheet([
                ['Snatch Park Bizsolutions Sdn Bhd'],
                [],
                ['CO+ Visa Master Transaction Report'],
                [`Date: ${moment(this.starttime.item.start).format('DD-MM-YYYY')} - ${moment(this.starttime.item.end).format('DD-MM-YYYY')}`],
                [],
                headers,
                ...rows,
            ]);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, sheet, 'VisaMasterReport');
            XLSX.writeFile(workbook, `CoherentVisaMasterReport_${this.isToday()}.csv`, { bookType: 'csv' });
        },
    }
}
</script>
